module.exports = __webpack_public_path__ + "static/media/geotechnical_investigation_see_far4.68ca65f1.jpeg";